import { lazy, Suspense } from 'react';
import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@/router/root-route';
import { JobEditWorkAreasLoadingFallback } from '@/features/jobs/job-edit-work-areas/JobEditWorkAreasLoadingFallback';

// EU-159 — lazy-load do JobEditWorkAreasPage para isolar o chunk com
// `exceljs` (~200KB gzip) do bundle inicial do recruiter-frontend. A página
// só carrega quando o consultor navega para `/vagas/:id/editar/vagas`.
// Reusa o LoadingFallback existente como fallback do `<Suspense>` —
// mantém UX coerente entre "chunk em download" e "GET em voo".
const JobEditWorkAreasPage = lazy(
  () => import('@/features/jobs/job-edit-work-areas/JobEditWorkAreasPage')
);

export const jobEditWorkAreasRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/vagas/$jobId/editar/vagas',
  component: () => (
    <Suspense fallback={<JobEditWorkAreasLoadingFallback />}>
      <JobEditWorkAreasPage />
    </Suspense>
  ),
});
